interface HeartIcon {
  isLiked?: boolean;
  onClick?: () => void;
}

function HeartIcon({ isLiked = false, onClick = () => {} }: HeartIcon) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer select-none"
      onClick={onClick}
    >
      <circle cx="16" cy="16" r="16" fill="#1A1A1A" fillOpacity="0.12" />
      {isLiked ? (
        <path
          d="M20.44 8.09961C18.63 8.09961 17.01 8.97961 16 10.3296C14.99 8.97961 13.37 8.09961 11.56 8.09961C8.49 8.09961 6 10.5996 6 13.6896C6 14.8796 6.19 15.9796 6.52 16.9996C8.1 21.9996 12.97 24.9896 15.38 25.8096C15.72 25.9296 16.28 25.9296 16.62 25.8096C19.03 24.9896 23.9 21.9996 25.48 16.9996C25.81 15.9796 26 14.8796 26 13.6896C26 10.5996 23.51 8.09961 20.44 8.09961Z"
          fill="#FC4040"
        />
      ) : (
        <path
          d="M16.0001 25.0413C15.7417 25.0413 15.4917 25.008 15.2834 24.933C12.1001 23.8413 7.04175 19.9663 7.04175 14.2413C7.04175 11.3247 9.40008 8.95801 12.3001 8.95801C13.7084 8.95801 15.0251 9.50801 16.0001 10.4913C16.9751 9.50801 18.2917 8.95801 19.7001 8.95801C22.6001 8.95801 24.9584 11.333 24.9584 14.2413C24.9584 19.9747 19.9001 23.8413 16.7167 24.933C16.5084 25.008 16.2584 25.0413 16.0001 25.0413ZM12.3001 10.208C10.0917 10.208 8.29175 12.0163 8.29175 14.2413C8.29175 19.933 13.7667 23.0997 15.6917 23.758C15.8417 23.808 16.1667 23.808 16.3167 23.758C18.2334 23.0997 23.7167 19.9413 23.7167 14.2413C23.7167 12.0163 21.9167 10.208 19.7084 10.208C18.4417 10.208 17.2667 10.7997 16.5084 11.8247C16.2751 12.1413 15.7417 12.1413 15.5084 11.8247C14.7334 10.7913 13.5667 10.208 12.3001 10.208Z"
          fill="white"
        />
      )}
    </svg>
  );
}

export default HeartIcon;
